import { dateFormat, datetime, isDateAfterStart, isDateBeforeStart, maxLength, presence, ValidationField, Validator } from "~/extensions/utils";
import validate, { isEmpty } from "validate.js";
import dayjs from "dayjs";
import { InformationTarget } from "~/extensions/utils/DefineTypes";
import { isNullOrUndefined, MypageMessageFormat } from "~/extensions/utils/DefineFunction";
import { commonStore } from "~/store/CommonStore";
export class AdminInformationValidator extends Validator {
    constructor(data) {
        const requiredErrorMessage = commonStore.messages.PV0001;
        const dateFormatErrorMessage = commonStore.messages.PV0005;
        const isDateBeforeStartErrorMessage = commonStore.messages.PV0006;
        const isDateAfterStartErrorMessage = commonStore.messages.PV0016;
        const pastDateErrorMessage = commonStore.messages.PV0007;
        const selectRequired = commonStore.messages.PV0002;
        let today = dayjs(new Date()).format("YYYY/MM/DD");
        const constrains = {
            startAt: {
                presence: presence(false, requiredErrorMessage),
                dateFormat: dateFormat(dateFormatErrorMessage),
                pastDate: pastDate({ dateOnly: false, earliest: today, tooEarly: pastDateErrorMessage }, "startAt")
            },
            endAt: {
                dateFormat: dateFormat(dateFormatErrorMessage),
                isDateBeforeStart: isDateBeforeStart(MypageMessageFormat(isDateBeforeStartErrorMessage, { val: "開始日", val1: "終了日" }), "startAt"),
                pastDate: pastDate({ dateOnly: false, earliest: today, tooEarly: pastDateErrorMessage }, "endAt")
            },
            target: {
                presence: presence(false, selectRequired)
            },
            nyukyokeiyakuNo: {
                targetContractorIfRequired: presence(false, requiredErrorMessage)
            },
            buknCd: {
                targetPropertyIfRequired: presence(false, requiredErrorMessage)
            },
            departmentCode: {
                targetDepartmentIfRequired: presence(false, selectRequired)
            },
            emailNotificationDate: {
                //すでにメール通知している場合は必須チェックを行わない
                emailNotificationIfRequired: data.isEmailNotification ? false : presence(false, requiredErrorMessage),
                dateFormat: dateFormat(dateFormatErrorMessage),
                isDateBeforeStart: isDateBeforeStart(MypageMessageFormat(isDateBeforeStartErrorMessage, { val: "通知日", val1: "掲載開始日" }), "startAt"),
                isDateAfterStart: isDateAfterStart(MypageMessageFormat(isDateAfterStartErrorMessage, { val: "通知日", val1: "掲載終了日" }), "endAt"),
                pastDate: pastDate({ dateOnly: false, earliest: today, tooEarly: pastDateErrorMessage }, "emailNotificationDate")
            },
            emailNotificationHour: {
                //すでにメール通知している場合は必須チェックを行わない
                emailNotificationIfRequired: data.isEmailNotification ? false : presence(false, selectRequired)
            },
            emailNotificationMinute: {
                //すでにメール通知している場合は必須チェックを行わない
                emailNotificationIfRequired: data.isEmailNotification ? false : presence(false, selectRequired)
            },
            subject: {
                presence: presence(false, requiredErrorMessage),
                length: maxLength(50)
            },
            main: {
                presence: presence(false, requiredErrorMessage),
                length: maxLength(500)
            },
            affirmativeText: {
                responseRequiredIfRequired: presence(false, requiredErrorMessage),
                length: maxLength(20)
            },
            negativeText: {
                length: maxLength(20)
            },
            responseDeadline: {
                dateFormat: dateFormat(dateFormatErrorMessage),
                isDateBeforeStart: isDateBeforeStart(MypageMessageFormat(isDateBeforeStartErrorMessage, { val: "回答期限", val1: "掲載開始日" }), "startAt"),
                isDateAfterStart: isDateAfterStart(MypageMessageFormat(isDateAfterStartErrorMessage, { val: "回答期限", val1: "掲載終了日" }), "endAt"),
                pastDate: pastDate({ dateOnly: false, earliest: today, tooEarly: pastDateErrorMessage }, "responseDeadline")
            }
        };
        super(data, constrains);
        this.startAt = new ValidationField("startAt", data, constrains);
        this.endAt = new ValidationField("endAt", data, constrains);
        this.target = new ValidationField("target", data, constrains);
        this.nyukyokeiyakuNo = new ValidationField("nyukyokeiyakuNo", data, constrains);
        this.buknCd = new ValidationField("buknCd", data, constrains);
        this.departmentCode = new ValidationField("departmentCode", data, constrains);
        this.emailNotificationDate = new ValidationField("emailNotificationDate", data, constrains);
        this.emailNotificationHour = new ValidationField("emailNotificationHour", data, constrains);
        this.emailNotificationMinute = new ValidationField("emailNotificationMinute", data, constrains);
        this.subject = new ValidationField("subject", data, constrains);
        this.main = new ValidationField("main", data, constrains);
        this.affirmativeText = new ValidationField("affirmativeText", data, constrains);
        this.negativeText = new ValidationField("negativeText", data, constrains);
        this.responseDeadline = new ValidationField("responseDeadline", data, constrains);
    }
    startAt;
    endAt;
    target;
    nyukyokeiyakuNo;
    buknCd;
    departmentCode;
    emailNotificationDate;
    emailNotificationHour;
    emailNotificationMinute;
    subject;
    main;
    affirmativeText;
    negativeText;
    responseDeadline;
}
validate.validators.pastDate = function (value, options, key, attributes) {
    if (isNullOrUndefined(value) || value === "") {
        return null;
    }
    if (attributes.model != null && attributes.model[options.isCheckProperty] === value && !attributes.isCopy) {
        return null;
    }
    let date = setDate(value);
    if (date === "") {
        return null;
    }
    let today = options.datetimeOptions.earliest;
    let is = date < today;
    if (is) {
        return options.datetimeOptions.tooEarly;
    }
    return null;
};
const setDate = (value) => {
    let stickDate;
    let splitDate = value.split("/");
    if (splitDate.length !== 3) {
        return "";
    }
    stickDate = splitDate[0] + "/" + stickString(splitDate[1]) + "/" + stickString(splitDate[2]);
    return stickDate;
};
const stickString = (value) => {
    if (value.length === 1) {
        value = "0" + value;
    }
    return value;
};
/**
 * 過去日チェック用オプション
 * @param options DatetimeOptions
 * @param isCheckProperty 変更検知用プロパティ名
 */
const pastDate = (options = null, isCheckProperty = null) => {
    return { datetimeOptions: validate.extend(datetime(options)), isCheckProperty: isCheckProperty };
};
/** 掲載対象が契約者の場合必須 */
validate.validators.targetContractorIfRequired = function (value, options, key, attributes) {
    if (attributes.target !== Number(InformationTarget.Contractor)) {
        return null;
    }
    if (isNullOrUndefined(value) || isEmpty(value)) {
        return options.message;
    }
    return null;
};
/** 掲載対象が物件の場合必須 */
validate.validators.targetPropertyIfRequired = function (value, options, key, attributes) {
    if (attributes.target !== Number(InformationTarget.Property)) {
        return null;
    }
    if (isNullOrUndefined(value) || isEmpty(value)) {
        return options.message;
    }
    return null;
};
/** 掲載対象が部署の場合必須 */
validate.validators.targetDepartmentIfRequired = function (value, options, key, attributes) {
    if (attributes.target !== Number(InformationTarget.Department)) {
        return null;
    }
    if (isNullOrUndefined(value) || isEmpty(value)) {
        return options.message;
    }
    return null;
};
/** メール通知ありの場合必須 */
validate.validators.emailNotificationIfRequired = function (value, options, key, attributes) {
    if (!attributes.isEmailNotification) {
        return null;
    }
    if (isNullOrUndefined(value) || isEmpty(value)) {
        return options.message;
    }
    return null;
};
/** 要回答の場合必須 */
validate.validators.responseRequiredIfRequired = function (value, options, key, attributes) {
    if (!attributes.isResponseRequired) {
        return null;
    }
    if (isNullOrUndefined(value) || isEmpty(value)) {
        return options.message;
    }
    return null;
};
